import Box, { BoxProps } from "ds/components/Box";
import useTypedContext from "hooks/useTypedContext";

import CardContent from "../../components/Content";
import { CardCollapsibleContext } from "./Context";
import styles from "./styles.module.css";

type CardCollapsibleContentProps = {
  fullbleed?: boolean;
  hasHeader?: boolean;
  gap?: BoxProps["gap"];
  children: BoxProps["children"];
};

function CardCollapsibleContent({
  children,
  fullbleed,
  hasHeader,
  gap,
}: CardCollapsibleContentProps) {
  const { isCollapsed, contentId } = useTypedContext(CardCollapsibleContext);

  return (
    <Box
      className={styles.collapsible}
      grid
      gridTemplate="1fr"
      id={contentId}
      {...(isCollapsed ? { ["aria-hidden"]: true } : null)}
    >
      <Box className={styles.collapsibleContent}>
        <CardContent hasHeader={hasHeader} fullbleed={fullbleed} gap={gap}>
          {children}
        </CardContent>
      </Box>
    </Box>
  );
}

CardCollapsibleContent.displayName = "DS.Card.Collapsible.Content";

export default CardCollapsibleContent;
